<template>
  <div :class="lucking.location.box_name + ' pointer'">
    <div :class="'box-list' + (isLucking ? ' lucking-box-list' : '')">
      <Row :gutter="10" class="t-c">
        <Col span="8">
          <div v-if="lucking.location.list.p1" :style="getGridItemStyle(lucking.location.list.p1)" :class="'box-item box-item-p1 pointer ' + (nowLuck === 1 ? 'box-item-now' : '')">
            <img src="http://vw-assets.welltuo.com/images/none.png" class="w100" />
          </div>
        </Col>
        <Col span="8">
          <div v-if="lucking.location.list.p2" :style="getGridItemStyle(lucking.location.list.p2)" :class="'box-item box-item-p2 pointer ' + (nowLuck === 2 ? 'box-item-now' : '')">
            <img src="http://vw-assets.welltuo.com/images/none.png" class="w100" />
          </div>
        </Col>
        <Col span="8">
          <div v-if="lucking.location.list.p3" :style="getGridItemStyle(lucking.location.list.p3)" :class="'box-item box-item-p3 pointer ' + (nowLuck === 3 ? 'box-item-now' : '')">
            <img src="http://vw-assets.welltuo.com/images/none.png" class="w100" />
          </div>
        </Col>
      </Row>
      <Row :gutter="10" class="m-t">
        <Col span="8">
          <div v-if="lucking.location.list.p8" :style="getGridItemStyle(lucking.location.list.p8)" :class="'box-item box-item-p8 pointer ' + (nowLuck === 8 ? 'box-item-now' : '')">
            <img src="http://vw-assets.welltuo.com/images/none.png" class="w100" />
          </div>
        </Col>
        <Col span="8">
          <div class="button pointer" :style="getLotteryButtonStyle()">
            <img @click="clickLucking" src="http://vw-assets.welltuo.com/images/none.png" class="w100" />
          </div>
        </Col>
        <Col span="8">
          <div v-if="lucking.location.list.p4" :style="getGridItemStyle(lucking.location.list.p4)" :class="'box-item box-item-p4 pointer ' + (nowLuck === 4 ? 'box-item-now' : '')">
            <img src="http://vw-assets.welltuo.com/images/none.png" class="w100" />
          </div>
        </Col>
      </Row>
      <Row :gutter="10" class="m-t">
        <Col span="8">
          <div v-if="lucking.location.list.p7" :style="getGridItemStyle(lucking.location.list.p7)" :class="'box-item box-item-p7 pointer ' + (nowLuck === 7 ? 'box-item-now' : '')">
            <img src="http://vw-assets.welltuo.com/images/none.png" class="w100" />
          </div>
        </Col>
        <Col span="8">
          <div v-if="lucking.location.list.p6" :style="getGridItemStyle(lucking.location.list.p6)" :class="'box-item box-item-p6 pointer ' + (nowLuck === 6 ? 'box-item-now' : '')">
            <img src="http://vw-assets.welltuo.com/images/none.png" class="w100" />
          </div>
        </Col>
        <Col span="8">
          <div v-if="lucking.location.list.p5" :style="getGridItemStyle(lucking.location.list.p5)" :class="'box-item box-item-p5 pointer ' + (nowLuck === 5 ? 'box-item-now' : '')">
            <img src="http://vw-assets.welltuo.com/images/none.png" class="w100" />
          </div>
        </Col>
      </Row>
    </div>
    <template v-if="iconList[lucking.location.box_name] && iconList[lucking.location.box_name].twinkle">
      <div :class="'lucking-icon icon-' + icon + (idx % 2 === 0 ? ' twinkle-' + lucking.location.icon_twinkle_speed: ' twinkle-un-' + lucking.location.icon_twinkle_speed)" v-for="(icon, idx) in iconList[lucking.location.box_name].twinkle" :key="'twinkle-' + idx"></div>
    </template>
    <template v-if="iconList[lucking.location.box_name] && iconList[lucking.location.box_name].basics">
      <div :class="'lucking-icon icon-' + icon" v-for="(icon, idx) in iconList[lucking.location.box_name].basics" :key="'basics-' + idx"></div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'LuckingGrid',
  props: {
    lucking: {
      type: Object
    },
    productList: {
      type: Object
    },
    iconList: {
      type: Object
    },
    runLucking: {
      type: Function
    }
  },
  data () {
    return {
      gridHeight: null,
      isLucking: false,
      nowLuck: 0,
      confirmLuck: null
    }
  },
  watch: {
  },
  methods: {
    setLucking (val) {
      var pId = 999
      for (var key in this.lucking.location.list) {
        if (this.lucking.location.list[key] === val) {
          pId = parseInt(key.substr(1))
        }
      }
      this.confirmLuck = pId
      // this.isLucking = false
    },
    goNowLuck (idx) {
      setTimeout(() => {
        if (idx <= 8) {
          this.nowLuck = idx
        } else {
          this.nowLuck = idx = 1
        }
        if (this.confirmLuck === this.nowLuck || this.confirmLuck === 999) {
          if (this.confirmLuck === 999) {
            this.nowLuck = 99
          }
        } else {
          this.goNowLuck(idx + 1)
        }
      }, 80)
    },
    clickLucking () {
      this.confirmLuck = null
      this.isLucking = true
      this.goNowLuck(1)
      this.$props.runLucking()
    },
    getLotteryButtonStyle () {
      var style = 'display: block;'
      style += 'background-image: url(' + this.lucking.location.lottery_button + ');'
      style += 'background-repeat: no-repeat;'
      style += 'background-position: center center;'
      style += 'background-size: contain;'
      return style
    },
    getGridItemStyle (pId) {
      var style = 'display: block;'
      if (pId === '_thank_coming_') {
        style += 'background-image: url(' + this.lucking.location.thank_coming + ');'
      } else {
        style += 'background-image: url(' + this.productList['p' + pId].image + ');'
      }
      style += 'background-repeat: no-repeat;'
      style += 'background-position: center center;'
      style += 'background-size: contain;'
      return style
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/lucking/grid.vue